// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"532":"styles","584":"linaria","998":"component---src-templates-home-js"}[chunkId] || chunkId) + "-" + {"155":"01bb63fde0697ace7621","175":"90a8c95520b339d11369","231":"86208b65d2abe04d2d46","532":"f42f00c1cdfa1f6913a1","584":"1ecdff971b785b64156e","998":"e01ce995b6e583c8e11e"}[chunkId] + ".js";
};